// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IFundingLevelSwitchingDto
 */
export interface IFundingLevelSwitchingDto {
    /**
     * 
     * @type {number}
     * @memberof IFundingLevelSwitchingDto
     */
    plan_id: number;
    /**
     * 
     * @type {number}
     * @memberof IFundingLevelSwitchingDto
     */
    org_id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IFundingLevelSwitchingDto
     */
    plan_level_funding?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IFundingLevelSwitchingDto
     */
    update_status: IFundingLevelSwitchingDtoUpdateStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof IFundingLevelSwitchingDto
     */
    details?: string;
}

/**
* @export
* @enum {string}
*/
export enum IFundingLevelSwitchingDtoUpdateStatusEnum {
    UPDATED = 'UPDATED',
    SKIPPED = 'SKIPPED',
    ERROR = 'ERROR',
    WARNING = 'WARNING'
}


/**
 * Check if a given object implements the IFundingLevelSwitchingDto interface.
 */
export function instanceOfIFundingLevelSwitchingDto(value: object): value is IFundingLevelSwitchingDto {
    if (!('plan_id' in value) || value['plan_id'] === undefined) return false;
    if (!('update_status' in value) || value['update_status'] === undefined) return false;
    return true;
}

export function IFundingLevelSwitchingDtoFromJSON(json: any): IFundingLevelSwitchingDto {
    return IFundingLevelSwitchingDtoFromJSONTyped(json, false);
}

export function IFundingLevelSwitchingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IFundingLevelSwitchingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plan_id': json['plan_id'],
        'org_id': json['org_id'] == null ? undefined : json['org_id'],
        'plan_level_funding': json['plan_level_funding'] == null ? undefined : json['plan_level_funding'],
        'update_status': json['update_status'],
        'details': json['details'] == null ? undefined : json['details'],
    };
}

export function IFundingLevelSwitchingDtoToJSON(json: any): IFundingLevelSwitchingDto {
    return IFundingLevelSwitchingDtoToJSONTyped(json, false);
}

export function IFundingLevelSwitchingDtoToJSONTyped(value?: IFundingLevelSwitchingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan_id': value['plan_id'],
        'org_id': value['org_id'],
        'plan_level_funding': value['plan_level_funding'],
        'update_status': value['update_status'],
        'details': value['details'],
    };
}

